import { render } from "./index.vue?vue&type=template&id=490bc7fd&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=490bc7fd&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-490bc7fd"

export default script